/* eslint-disable */
// @ts-nocheck
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, isDevMode } from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { MasterKey } from '../../models/master-key'
import { SystemProfileViewModel } from '../../models/keying-models'
import { ProfileService } from '../../services/profile.service'
import { MasterKeyService } from '../../services/master-key.service'
import { OnChanges } from '@angular/core'
import { DealerMasterKey, DealerMasterKeyRequest } from '@overtur-monorepo/keying-shared'
import { KeyNodeType } from '@overtur-monorepo/keying-shared'

@Component({
  selector: 'lib-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrls: ['./hierarchy.component.scss'],
  standalone: false,
})
export class HierarchyComponent implements OnInit, OnDestroy, OnChanges {
  @Input() masterKeys: MasterKey
  @Input() keySystem
  @Input() structure
  @Input() crossKeyHierarchy = false
  @Input() ownOperatingKey = false
  @Input() budgetHierarchy = false
  @Input() showChangeKeys = true
  @Input() onlyTree = false
  @Input() selectedMasterKey: MasterKey
  @Input() keyways = []
  @Input() heightOffset = '0'
  @Input() dealerMasterKeys: DealerMasterKey[]
  @Input() showDealerMasterKeyTree = false

  @Output() selectKey = new EventEmitter<MasterKey>()
  @Output() deleteItemAction = new EventEmitter<MasterKey>()
  @Output() deleteChildrenAction = new EventEmitter<any>()
  @Output() patchItemAction = new EventEmitter<any>()
  @Output() addChildAction = new EventEmitter<MasterKey>()
  @Output() selectedMasterKeys = new EventEmitter<MasterKey[]>()
  @Output() dealererror = new EventEmitter<any>()
  @Output() isEditing = new EventEmitter<any>()

  formattedHierarchyItems: MasterKey = new MasterKey()
  destroy$ = new Subject()
  flattenedItems: Array<MasterKey>

  isResidentialSystem = false

  isDevModeFn = isDevMode

  showUnassignedKeys = false
  keyNodeType = KeyNodeType
  showNoKeysMessage = false

  unAssignedKeys: MasterKey[] = []

  constructor(private profileService: ProfileService, private masterKeyService: MasterKeyService) {}

  ngOnInit() {
    this.masterKeyService.selectedMasters$.pipe(takeUntil(this.destroy$)).subscribe((res: MasterKey[]) => {
      this.selectedMasterKeys.emit(res)
    })

    this.masterKeyService.masterKeys$.pipe(takeUntil(this.destroy$)).subscribe((res: MasterKey) => {
      if (!res) {
        return
      }
      this.formattedHierarchyItems = res
      if (!this.selectedMasterKey) {
        this.selectIncludedParent(this.formattedHierarchyItems)
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
    this.masterKeyService.setSelectedMasterKey(null)
  }

  isEditingFunction(event) {
    this.isEditing.emit(event)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.masterKeys && this.masterKeys) {
      this.setUp()
    }
  }

  flatten(items: MasterKey) {
    for (const child of items.children) {
      this.flatten(child)
      this.flattenedItems.push(child)
    }
  }

  setUp() {
    this.masterKeyService.setMasterKeys(this.masterKeys)
  }

  selectIncludedParent(masterKey: MasterKey) {
    this.masterKeyService.setSelectedMasterKey(masterKey)
    this.selectKey.emit(masterKey)
  }

  patchItem(patchData) {
    this.patchItemAction.emit(patchData)
  }

  deleteItem(hierarchyItem): void {
    this.deleteItemAction.emit(hierarchyItem)
  }

  deleteChildren(deleteData) {
    this.deleteChildrenAction.emit(deleteData)
  }

  addChild(data) {
    this.addChildAction.emit(data)
  }

  handleDealerError(error: any) {
    this.dealererror.emit(error)
  }

  toggleUnassignedKeys() {
    this.showUnassignedKeys = !this.showUnassignedKeys
    this.checkShowNoKeysMessage()
  }

  /*istanbul ignore next*/
  checkShowNoKeysMessage() {
    if (this.showUnassignedKeys) {
      this.showNoKeysMessage = !this.formattedHierarchyItems
        .squashIncludeChangeKeys()
        .some((key) => key.showOnUnassignedToggle)
    } else {
      this.showNoKeysMessage = false
    }
  }
}
